var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Graph2d',{ref:"graph2d",attrs:{"items":_vm.items,"groups":_vm.groups,"options":_vm.options,"events":['rangechanged']},on:{"rangechanged":_vm.rangeChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }